import { useNavigate } from "react-router-dom";
import { Icon } from "../icon/icon";

export const BackButton = ({
  onClick,
  text = "Back",
  className = "",
}: {
  onClick?: () => void;
  text?: string;
  className?: string;
}) => {
  const navigate = useNavigate();

  return (
    <button
      className={`flex w-fit items-center gap-2 p-2 ${className}`}
      onClick={() => {
        if (onClick) {
          onClick();
        } else {
          navigate(-1);
        }
      }}
    >
      <Icon
        svg="arrow-right"
        width={20}
        height={20}
        className="soft-shrink rotate-180"
      />
      <span className="text-sm font-bold">{text}</span>
    </button>
  );
};
